import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';

@Injectable({
  providedIn: 'root'
})
export class A02Guard implements CanActivate {

  constructor(private router: Router, private globalVar: GlobalVar) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    //console.log(this.globalVar.mine);
    if (this.globalVar.mine && this.globalVar.mine.permissionList && this.globalVar.mine.permissionList.length > 0) {
      for (let i = 0; i < this.globalVar.mine.permissionList.length; i++) {
        if ((this.globalVar.mine.permissionList[i].roleId == 'A02' && this.globalVar.mine.permissionList[i].e == true) || this.globalVar.mine.isAdmin == true) {
          return true;
        }
      }
    }

    this.router.navigate(['/page401']);
    //alert('權限不足，無法進入');
    return false;
  }

  canDeactivate(component: any) {
    //if (component.memberForm && component.memberForm.dirty) {
    //  return window.confirm("您有異動過的資料，是否確定要離開?");
    //}
    //else {
    //  return true;
    //}

    if (component.driveList && component.driveList.length > 0) {   //車程維護
      if (JSON.stringify(component.driveList) != component.driveListStr) {
        return window.confirm("偵測到有修改的資料尚未存檔，確認要離開頁面?");
      }
      else {
        return true;
      }
    }
    else if (component.presetList && component.presetList.length > 0) {   //預排班表
      if (JSON.stringify(component.presetList) != component.presetListStr) {
        return window.confirm("偵測到有修改的資料尚未存檔，確認要離開頁面?");
      }
      else {
        return true;
      }
    }
    else if (component.rosterList && component.rosterList.length > 0) {
      if (JSON.stringify(component.rosterList) != component.rosterListStr) {
        return window.confirm("偵測到有修改的資料尚未存檔，確認要離開頁面?");
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }

  }
  
}
